import { ClassNameProvider } from '@/styles/Adunit';
import type { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { Adunit } from './Adunit';

export interface StandaloneAdunitProps extends StandaloneComponentProps<typeof Adunit> {
  title: React.ReactNode;
  data: {
    elID?: string;
    placement?: string;
  };
}

export const StandaloneAdunit: StandaloneComponent<StandaloneAdunitProps> = ({ title, data, options, ...props }) => {
  const { $placement, $wrapper, ...$base } = options ?? {};

  const { elID, placement } = data ?? {};

  return (
    <ClassNameProvider value={$base}>
      <Adunit {...$base} {...props}>
        {title}
        <Adunit.Wrapper {...$wrapper}>
          <Adunit.Placement id={elID} ad-placement={placement} {...$placement} />
        </Adunit.Wrapper>
      </Adunit>
    </ClassNameProvider>
  );
};

export default StandaloneAdunit;
